import { app } from '../app';

app.factory('RegistrationCodeGeneratonService', RegistrationCodeGeneratonService);

/** @ngInject */
function RegistrationCodeGeneratonService($resource) {
    return $resource('app/rest/registrationcode/:uuid', {}, {
        "simulatorBarcode" : {
            method : 'GET',
            url : 'app/rest/registrationcode/simulator/:uuid?appKey=:appKey',
            params : {
                uuid : '@uuid',
                appKey : '@appKey'
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/portal/services/registration-code-generation.service.js